import { Injectable } from '@angular/core';
import { Response, Http } from "@angular/http";
import { AuthHttp } from "angular2-jwt";
import "rxjs/Rx";
import { environment } from "../../../environments/environment";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Observer, Subject } from 'rxjs/Rx';

@Injectable()
export class UserAgreementService {

  constructor(private authHttp: AuthHttp, private http: Http) {}

  userAgreementLoaded = new Subject();

  userAgreement: {
    userAgreementId: number,
    userAgreementContent: string,
    userAgreementTypeId: number,
    isActive: boolean,
    modifiedBy: number,
    modified: Date,
    validFrom: Date,
    validTo: Date
  } = null;


  load() {
    this.userAgreement = null;

    const qs = environment.apiPath + '/api/lookups/getUserAgreement';

    return this.http
      .get(qs)
      .map((res: Response) => res.json())
      .toPromise()
      .then((data: any) => { this.userAgreement = data; this.userAgreementLoaded.next(); })
      .catch((err: any) => Promise.resolve());
  }

  public getUserAgreement() {
    return this.userAgreement;
  }
}





// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/lookups/user-agreement.service.ts